import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LayoutDashboard, CheckSquare, Wrench, BarChart3, Trophy, Check } from 'lucide-react';
export function AppDemo() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const tabs = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: <LayoutDashboard className="w-4 h-4" data-id="element-25" />
  }, {
    id: 'protocol',
    label: 'Protocolo',
    icon: <CheckSquare className="w-4 h-4" data-id="element-26" />
  }, {
    id: 'toolkit',
    label: 'Toolkit',
    icon: <Wrench className="w-4 h-4" data-id="element-27" />
  }, {
    id: 'tracker',
    label: 'Tracker',
    icon: <BarChart3 className="w-4 h-4" data-id="element-28" />
  }, {
    id: 'gamification',
    label: 'Gamificación',
    icon: <Trophy className="w-4 h-4" data-id="element-29" />
  }];
  return <section className="py-24 px-6 bg-brand-bg" data-id="element-30">
      <div className="max-w-[1000px] mx-auto" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-33">
            Mira la App en Acción
          </h2>
          <p className="text-xl text-brand-muted" data-id="element-34">
            Esto es lo que abres CADA MAÑANA en lugar de leer 200 páginas
          </p>
        </motion.div>

        {/* Tab Selector */}
        <div className="flex overflow-x-auto hide-scrollbar justify-start md:justify-center gap-2 mb-12 pb-4" data-id="element-35">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-5 py-3 rounded-full text-sm font-bold whitespace-nowrap transition-all ${activeTab === tab.id ? 'bg-brand-cyan text-black shadow-[0_0_20px_rgba(0,212,170,0.3)]' : 'bg-brand-card text-brand-muted hover:text-white border border-brand-border'}`} data-id="element-36">
              {tab.icon}
              {tab.label}
            </button>)}
        </div>

        {/* App Mockup Container */}
        <div className="flex justify-center" data-id="element-37">
          <div className="relative w-full max-w-[320px] h-[640px] bg-brand-bg rounded-[40px] border-[4px] border-brand-border p-4 shadow-2xl overflow-hidden" data-id="element-38">
            <div className="absolute inset-0 bg-brand-cyan/5 pointer-events-none" data-id="element-39" />

            <AnimatePresence mode="wait" data-id="element-40">
              {/* DASHBOARD TAB */}
              {activeTab === 'dashboard' && <motion.div key="dashboard" initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.3
            }} className="h-full flex flex-col" data-id="element-41">
                  <div className="flex justify-between items-center mb-6 mt-2" data-id="element-42">
                    <span className="font-bold text-white text-sm" data-id="element-43">
                      🧬 BIO-X 90
                    </span>
                    <span className="text-brand-muted" data-id="element-44">⚙️</span>
                  </div>

                  <div className="bg-brand-card rounded-xl p-4 mb-4 border border-brand-border" data-id="element-45">
                    <p className="text-white font-bold mb-2" data-id="element-46">Día 8 de 90</p>
                    <div className="w-full h-2 bg-brand-bg rounded-full overflow-hidden" data-id="element-47">
                      <div className="w-[9%] h-full bg-brand-cyan rounded-full" data-id="element-48" />
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-49">
                    <div className="bg-brand-card rounded-lg p-2 text-center border border-brand-border" data-id="element-50">
                      <p className="text-[10px] text-brand-muted mb-1" data-id="element-51">
                        Energía
                      </p>
                      <p className="text-sm font-bold text-white" data-id="element-52">⚡7/10</p>
                    </div>
                    <div className="bg-brand-card rounded-lg p-2 text-center border border-brand-border" data-id="element-53">
                      <p className="text-[10px] text-brand-muted mb-1" data-id="element-54">Racha</p>
                      <p className="text-sm font-bold text-white" data-id="element-55">🔥 8</p>
                    </div>
                    <div className="bg-brand-card rounded-lg p-2 text-center border border-brand-border" data-id="element-56">
                      <p className="text-[10px] text-brand-muted mb-1" data-id="element-57">Score</p>
                      <p className="text-sm font-bold text-white" data-id="element-58">📊 6.8</p>
                    </div>
                  </div>

                  <div className="bg-brand-card rounded-xl p-4 mb-4 border border-brand-border h-[100px] relative overflow-hidden flex-shrink-0" data-id="element-59">
                    <p className="text-xs text-white font-bold mb-2 relative z-10" data-id="element-60">
                      Tendencia Semanal
                    </p>
                    <div className="absolute bottom-0 left-0 w-full h-[60px] bg-gradient-to-t from-brand-purple/20 to-transparent" data-id="element-61" />
                    <svg className="absolute bottom-0 left-0 w-full h-[60px]" preserveAspectRatio="none" viewBox="0 0 100 100" data-id="element-62">
                      <path d="M0,100 L0,50 L20,70 L40,30 L60,60 L80,20 L100,40 L100,100 Z" fill="rgba(123,104,238,0.3)" data-id="element-63" />
                      <path d="M0,50 L20,70 L40,30 L60,60 L80,20 L100,40" fill="none" stroke="#7B68EE" strokeWidth="2" data-id="element-64" />
                    </svg>
                  </div>

                  <div className="bg-brand-cyan/10 rounded-xl p-4 border border-brand-cyan/20 mt-auto mb-16" data-id="element-65">
                    <p className="text-xs text-brand-cyan leading-relaxed" data-id="element-66">
                      🧠 <strong data-id="element-67">Insight:</strong> Tu cerebro es 60% grasa. El
                      Omega-3 es su combustible principal. Asegúrate de tomar tu
                      dosis hoy.
                    </p>
                  </div>
                </motion.div>}

              {/* PROTOCOL TAB */}
              {activeTab === 'protocol' && <motion.div key="protocol" initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.3
            }} className="h-full flex flex-col" data-id="element-68">
                  <div className="text-center mb-6 mt-2" data-id="element-69">
                    <span className="font-bold text-white text-sm" data-id="element-70">
                      Protocolo Diario — Día 8
                    </span>
                  </div>

                  <div className="flex justify-between items-center mb-6 px-2" data-id="element-71">
                    <span className="text-xs text-brand-muted" data-id="element-72">L</span>
                    <span className="text-xs text-brand-muted" data-id="element-73">M</span>
                    <div className="w-6 h-6 rounded-full bg-brand-cyan flex items-center justify-center" data-id="element-74">
                      <span className="text-xs text-black font-bold" data-id="element-75">X</span>
                    </div>
                    <span className="text-xs text-brand-muted" data-id="element-76">J</span>
                    <span className="text-xs text-brand-muted" data-id="element-77">V</span>
                    <span className="text-xs text-brand-muted" data-id="element-78">S</span>
                    <span className="text-xs text-brand-muted" data-id="element-79">D</span>
                  </div>

                  <div className="mb-6" data-id="element-80">
                    <div className="flex justify-between text-xs mb-1" data-id="element-81">
                      <span className="text-white" data-id="element-82">Progreso</span>
                      <span className="text-brand-cyan font-bold" data-id="element-83">75%</span>
                    </div>
                    <div className="w-full h-1.5 bg-brand-card rounded-full overflow-hidden" data-id="element-84">
                      <div className="w-[75%] h-full bg-brand-cyan rounded-full" data-id="element-85" />
                    </div>
                  </div>

                  <div className="space-y-3" data-id="element-86">
                    <div className="bg-brand-card rounded-xl p-4 border border-brand-border flex items-center gap-3" data-id="element-87">
                      <div className="w-5 h-5 rounded-full border-2 border-brand-cyan" data-id="element-88" />
                      <span className="text-sm text-white font-medium" data-id="element-89">
                        Ventana ayuno 16:8
                      </span>
                    </div>
                    <div className="bg-brand-card rounded-xl p-4 border border-brand-border flex items-center gap-3" data-id="element-90">
                      <div className="w-5 h-5 rounded-full border-2 border-brand-purple" data-id="element-91" />
                      <span className="text-sm text-white font-medium" data-id="element-92">
                        Magnesio glicinato
                      </span>
                    </div>
                    <div className="bg-brand-card rounded-xl p-4 border border-brand-cyan/50 bg-brand-cyan/5 flex items-center gap-3 opacity-60" data-id="element-93">
                      <div className="w-5 h-5 rounded-full bg-brand-cyan flex items-center justify-center" data-id="element-94">
                        <Check className="w-3 h-3 text-black" data-id="element-95" />
                      </div>
                      <span className="text-sm text-white font-medium line-through" data-id="element-96">
                        Ducha fría 90 seg
                      </span>
                    </div>
                    <div className="bg-brand-card rounded-xl p-4 border border-brand-border flex items-center gap-3" data-id="element-97">
                      <div className="w-5 h-5 rounded-full border-2 border-brand-gold" data-id="element-98" />
                      <span className="text-sm text-white font-medium" data-id="element-99">
                        Cero pantallas PM
                      </span>
                    </div>
                  </div>

                  <div className="mt-auto mb-16 text-center" data-id="element-100">
                    <p className="text-[10px] text-brand-muted" data-id="element-101">
                      Al completar → 🎉 animación de celebración + streak
                    </p>
                  </div>
                </motion.div>}

              {/* TOOLKIT TAB */}
              {activeTab === 'toolkit' && <motion.div key="toolkit" initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.3
            }} className="h-full flex flex-col" data-id="element-102">
                  <div className="text-center mb-6 mt-2" data-id="element-103">
                    <span className="font-bold text-white text-sm" data-id="element-104">
                      Caja de Herramientas
                    </span>
                  </div>

                  <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-105">
                    <div className="bg-brand-card rounded-xl p-4 border border-brand-border text-center" data-id="element-106">
                      <span className="text-2xl mb-2 block" data-id="element-107">⏱️</span>
                      <span className="text-xs text-white font-bold" data-id="element-108">
                        Calc. Ayuno
                      </span>
                    </div>
                    <div className="bg-brand-card rounded-xl p-4 border border-brand-border text-center" data-id="element-109">
                      <span className="text-2xl mb-2 block" data-id="element-110">🧊</span>
                      <span className="text-xs text-white font-bold" data-id="element-111">
                        Prot. Frío
                      </span>
                    </div>
                    <div className="bg-brand-card rounded-xl p-4 border border-brand-border text-center col-span-2" data-id="element-112">
                      <span className="text-2xl mb-2 block" data-id="element-113">📊</span>
                      <span className="text-xs text-white font-bold" data-id="element-114">
                        Score Bio-X
                      </span>
                    </div>
                  </div>

                  <div className="bg-gradient-to-br from-brand-cyan/20 to-brand-purple/20 rounded-xl p-5 border border-brand-cyan/30 mb-6" data-id="element-115">
                    <p className="text-xs text-brand-cyan font-bold uppercase mb-2" data-id="element-116">
                      Guía Rápida
                    </p>
                    <p className="text-lg text-white font-bold mb-1" data-id="element-117">
                      🧊 Hormesis Térmica
                    </p>
                    <p className="text-xs text-white/80" data-id="element-118">
                      Desliza para ver protocolo →
                    </p>
                  </div>

                  <div className="bg-brand-card rounded-xl p-4 border border-brand-border mt-auto mb-16" data-id="element-119">
                    <p className="text-xs text-white font-bold mb-3" data-id="element-120">
                      Suplementos Base
                    </p>
                    <div className="space-y-2" data-id="element-121">
                      <div className="flex justify-between text-xs" data-id="element-122">
                        <span className="text-brand-muted" data-id="element-123">Omega-3</span>
                        <span className="text-white" data-id="element-124">2g / mañana</span>
                      </div>
                      <div className="flex justify-between text-xs" data-id="element-125">
                        <span className="text-brand-muted" data-id="element-126">Magnesio</span>
                        <span className="text-white" data-id="element-127">400mg / noche</span>
                      </div>
                    </div>
                  </div>
                </motion.div>}

              {/* TRACKER TAB */}
              {activeTab === 'tracker' && <motion.div key="tracker" initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.3
            }} className="h-full flex flex-col" data-id="element-128">
                  <div className="text-center mb-6 mt-2" data-id="element-129">
                    <span className="font-bold text-white text-sm" data-id="element-130">
                      Registro Diario
                    </span>
                  </div>

                  <div className="space-y-6 mb-8" data-id="element-131">
                    <div data-id="element-132">
                      <div className="flex justify-between text-xs mb-2" data-id="element-133">
                        <span className="text-white" data-id="element-134">Energía</span>
                        <span className="text-brand-cyan font-bold" data-id="element-135">7/10</span>
                      </div>
                      <div className="w-full h-2 bg-brand-card rounded-full" data-id="element-136">
                        <div className="w-[70%] h-full bg-brand-cyan rounded-full relative" data-id="element-137">
                          <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-white rounded-full shadow" data-id="element-138" />
                        </div>
                      </div>
                    </div>

                    <div data-id="element-139">
                      <div className="flex justify-between text-xs mb-2" data-id="element-140">
                        <span className="text-white" data-id="element-141">Sueño</span>
                        <span className="text-brand-purple font-bold" data-id="element-142">
                          8/10
                        </span>
                      </div>
                      <div className="w-full h-2 bg-brand-card rounded-full" data-id="element-143">
                        <div className="w-[80%] h-full bg-brand-purple rounded-full relative" data-id="element-144">
                          <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-white rounded-full shadow" data-id="element-145" />
                        </div>
                      </div>
                    </div>

                    <div data-id="element-146">
                      <div className="flex justify-between text-xs mb-2" data-id="element-147">
                        <span className="text-white" data-id="element-148">Claridad</span>
                        <span className="text-brand-gold font-bold" data-id="element-149">6/10</span>
                      </div>
                      <div className="w-full h-2 bg-brand-card rounded-full" data-id="element-150">
                        <div className="w-[60%] h-full bg-brand-gold rounded-full relative" data-id="element-151">
                          <div className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 bg-white rounded-full shadow" data-id="element-152" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-brand-card rounded-xl p-4 border border-brand-border text-center mb-6" data-id="element-153">
                    <p className="text-xs text-white font-bold mb-3" data-id="element-154">
                      Mood de hoy
                    </p>
                    <div className="flex justify-between px-2 text-2xl opacity-50" data-id="element-155">
                      <span data-id="element-156">😫</span>
                      <span data-id="element-157">😐</span>
                      <span className="opacity-100 scale-125 transition-transform" data-id="element-158">
                        🚀
                      </span>
                      <span data-id="element-159">🔥</span>
                    </div>
                  </div>

                  <div className="mt-auto mb-16 text-center" data-id="element-160">
                    <button className="w-full py-3 bg-brand-cyan text-black font-bold rounded-xl text-sm" data-id="element-161">
                      Guardar Registro
                    </button>
                  </div>
                </motion.div>}

              {/* GAMIFICATION TAB */}
              {activeTab === 'gamification' && <motion.div key="gamification" initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.3
            }} className="h-full flex flex-col" data-id="element-162">
                  <div className="text-center mb-6 mt-2" data-id="element-163">
                    <span className="font-bold text-white text-sm" data-id="element-164">Logros</span>
                  </div>

                  <div className="bg-brand-card rounded-xl p-5 border border-brand-border text-center mb-6" data-id="element-165">
                    <span className="text-4xl mb-2 block" data-id="element-166">🔥</span>
                    <p className="text-2xl font-black text-white" data-id="element-167">8 Días</p>
                    <p className="text-xs text-brand-muted" data-id="element-168">Racha actual</p>
                  </div>

                  <div className="mb-6" data-id="element-169">
                    <div className="flex justify-between text-xs mb-2" data-id="element-170">
                      <span className="text-white font-bold" data-id="element-171">
                        Nivel 3: Ejecutivo Consciente
                      </span>
                      <span className="text-brand-gold font-bold" data-id="element-172">
                        1,500 XP
                      </span>
                    </div>
                    <div className="w-full h-2 bg-brand-card rounded-full overflow-hidden" data-id="element-173">
                      <div className="w-[60%] h-full bg-brand-gold rounded-full" data-id="element-174" />
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-3 mt-auto mb-16" data-id="element-175">
                    <div className="aspect-square bg-brand-cyan/20 rounded-xl border border-brand-cyan/30 flex items-center justify-center text-2xl" data-id="element-176">
                      🧊
                    </div>
                    <div className="aspect-square bg-brand-purple/20 rounded-xl border border-brand-purple/30 flex items-center justify-center text-2xl" data-id="element-177">
                      🧘‍♂️
                    </div>
                    <div className="aspect-square bg-brand-gold/20 rounded-xl border border-brand-gold/30 flex items-center justify-center text-2xl" data-id="element-178">
                      🥗
                    </div>
                    <div className="aspect-square bg-brand-card rounded-xl border border-brand-border flex items-center justify-center text-2xl opacity-30 grayscale" data-id="element-179">
                      🏃‍♂️
                    </div>
                    <div className="aspect-square bg-brand-card rounded-xl border border-brand-border flex items-center justify-center text-2xl opacity-30 grayscale" data-id="element-180">
                      💤
                    </div>
                    <div className="aspect-square bg-brand-card rounded-xl border border-brand-border flex items-center justify-center text-2xl opacity-30 grayscale" data-id="element-181">
                      👑
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>

            {/* Global Bottom Nav (Static for mockup) */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-4 bg-brand-card px-6 py-3 rounded-full border border-brand-border z-20" data-id="element-182">
              {tabs.map(tab => <div key={tab.id} className={`w-2 h-2 rounded-full transition-colors ${activeTab === tab.id ? 'bg-brand-cyan' : 'bg-brand-muted'}`} data-id="element-183" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}